if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      let content = this.innerHTML;
      let titleFlag = false;
      // Les métachamps sont rendus enrobés dans un <span class="metafield-...">, dont la balise
      // ouvrante casserait la structure du tableau si elle était laissée dans le contenu.
      content = content.replace(/<\/?span[^>]*>/gi, '');
      content = content.replace(/<br\s*\/?>/gi, '\n');
      content = content.replace(/<\/p>|<\/div>/gi, '');
      content = content.split('<p>');
      if ( content.length === 1 ) {
        content = ['', content[0]];
      }
      for ( let i = 1; i < content.length; i++ ) {
        let contentArray = content[i].split('\n');

        contentDOM += `<div class="table">`

        if ( this.dataset.titleLabelLeft !== '' || this.dataset.titleLabelRight !== '' ) {
          if ( !titleFlag ) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            if ( this.dataset.titleLabelLeft !== '' ) {
              contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
            }
            if ( this.dataset.titleLabelRight !== '' ) {
              contentDOM += `<span>${this.dataset.titleLabelRight}</span>`;
            }
            contentDOM += `</span>`;
          }
        }

        for ( let j = 0; j < contentArray.length; j++ ) {
          let line = contentArray[j].trim();
          if ( line.length > 0 ) {
            // Seul un tiret en début de ligne indente : un tiret ailleurs appartient au texte.
            let isIndent = line.charAt(0) === '-';
            if ( isIndent ) {
              line = line.replace(/^-\s*/, '');
            }
            let comma = line.indexOf(',');
            let contentBlockArray = comma === -1 ? [line] : [line.slice(0, comma), line.slice(comma + 1)];
            contentDOM += `<span class="table-line ${(isIndent ? 'table-line--indent' : '')}">`;
            for ( let k = 0; k < contentBlockArray.length; k++ ) {
              let cell = contentBlockArray[k].trim();
              if ( cell.length > 0 ) {
                contentDOM += `<span>${cell}</span>`
              }
            }
            contentDOM += `</span>`;
          }
        }

        contentDOM += `</div>`;

      }
      
      this.innerHTML = contentDOM;

    }
  }

  if ( typeof customElements.get('nutritional-info') === 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}
